import { Dialog, DialogContent, Divider, Grid, makeStyles, Modal, Theme, Typography } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import React, { FC } from 'react';
import { format } from 'date-fns';
import NumberFormat from 'components/NumberFormat';
import { YELLOW_MOBILE } from 'constants/colors';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    rowGap: '1em',
    padding: '1em'
  },
  titleContainer: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.08)'
  }
}));
interface Props {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  historyResource: {
    createdAt: string;
    price: number;
    discount: number;
    quantity: number;
    totalPrice: number;
    orderDate: string;
    totalItem: number;
    discountUnit: number;
  }[];
}
const ModalHistory: FC<Props> = ({ open, setOpen, historyResource }) => {
  const classes = useStyles();

  return (
    <Dialog open={open}>
      <Grid xs={12} container className={classes.container}>
        <Grid xs={12} container justify='space-between' alignItems='center' className={classes.titleContainer}>
          <Typography variant='h5'>Riwayat Harga</Typography>
          <Close style={{ cursor: 'pointer' }} onClick={() => setOpen(false)} />
        </Grid>
        <Grid xs={12}>
          <Grid xs={12}>
            {historyResource.length > 0 && (
              <Grid xs={12} style={{ margin: '0.5em 0' }}>
                <Typography variant='h6' style={{ color: YELLOW_MOBILE, fontWeight: 500 }}>
                  Riwayat 5 penjualan terakhir:
                </Typography>
                <Grid xs={12} container justify='space-between'>
                  <Grid xs={4}>
                    <Typography style={{ color: 'lightgrey' }}>Harga/item sebelum disc</Typography>
                  </Grid>
                  <Grid xs={3}>
                    <Typography style={{ color: 'lightgrey' }}>Diskon/</Typography>
                    <Typography style={{ color: 'lightgrey' }}>item</Typography>
                  </Grid>
                  <Grid xs={1}>
                    <Typography style={{ color: 'lightgrey' }}>Qty</Typography>
                  </Grid>
                  <Grid xs={3}>
                    <Typography style={{ color: 'lightgrey' }}>Harga/item sesudah disc</Typography>
                  </Grid>
                  {historyResource.map((value, key) => (
                    <Grid xs={12} container justify='space-between' key={key}>
                      <Grid xs={4}>
                        <Typography>
                          <NumberFormat value={value.price + value.discountUnit} prefix={'Rp'} thousandSeparator={true} displayType='text' />
                        </Typography>
                        <Typography style={{ color: 'lightgrey', fontSize: '12px' }}>{format(new Date(value.orderDate), 'dd-MM-yyyy')}</Typography>
                      </Grid>
                      <Grid xs={3}>
                        <Typography>
                          <NumberFormat value={value.discountUnit} prefix={'Rp'} thousandSeparator={true} displayType='text' />
                        </Typography>
                      </Grid>
                      <Grid xs={1}>
                        <Typography>{value.totalItem}</Typography>
                      </Grid>
                      <Grid xs={3}>
                        <Typography>
                          <NumberFormat value={value.price} prefix={'Rp'} thousandSeparator={true} displayType='text' />
                        </Typography>
                      </Grid>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            )}

            {historyResource.length < 3 && historyResource.length > 0 && (
              <Typography style={{ color: 'lightgrey' }}>Mitra ini belum memiliki 5 penjualan sampai saat ini</Typography>
            )}
          </Grid>
          {/* {historyResource.length > 0 ? (
            historyResource.map((history, key) => (
              <Grid xs={12} container key={key}>
                <Grid xs={6}>
                  <Typography>
                    {key + 1} . {format(new Date(history.createdAt), 'dd MMM yyyy')}
                  </Typography>
                </Grid>
                <Grid xs={6}>
                  <Typography align='right'>
                    <NumberFormat value={history.price} prefix={'Rp'} thousandSeparator={true} displayType='text' />
                  </Typography>
                </Grid>
              </Grid>
            ))
          ) : (
            <Grid xs={12}>
              <Typography>Riwayat harga tidak ada</Typography>
            </Grid>
          )} */}
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default ModalHistory;
